import { useState } from 'react'

type CopiedValue = string | number | null
type CopyFn = (text: string | number) => Promise<boolean>

function useClipboard(): [CopiedValue, CopyFn] {
  const [copiedText, setCopiedText] = useState<CopiedValue>(null)

  const copy: CopyFn = async (text) => {
    if (!navigator?.clipboard) {
      // Caso o navegador não tenha suporte para clipboard
      const textArea = document.createElement('textarea')
      textArea.value = String(text)

      textArea.style.position = 'fixed'
      textArea.style.left = '-999999px'
      textArea.style.top = '-999999px'

      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()

      return new Promise((res, rej) => {
        if (document.execCommand('copy')) {
          res(true)
        } else {
          rej()
        }

        textArea.remove()
      })
    }

    try {
      await navigator.clipboard.writeText(String(text))
      setCopiedText(text)

      return true
    } catch (error) {
      setCopiedText(null)
      return false
    }
  }

  return [copiedText, copy]
}

export default useClipboard
